export const getInitialChar = (s: string) => {
  const matches = s.match(/\b(\w)/g); 
  const acronym = (matches || []).slice(1).join(""); 

  return acronym;
};
